import { useLang } from '@/i18n';
import css from './index.module.scss';
import { useEffect, useState } from 'react';

const D: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secneD = AniContainer.create({
                triggerElement: '.stream-ultra-x-B',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secneD.destroy();
            };
        }
    }, []);

    return (
        <section
            className={`${css.section} stream-ultra-x-D GtmModuleData-section`}
            id="stream-ultra-x-D"
            data-section-id={'stream-ultra-x-D'}
            data-section-title={t('D_title')}
        >
            <div className="eco-video">
                {load && (
                    <video
                        className="eco-video"
                        src="https://websiteoss.ecoflow.com/upload/video/1753865093504/4.mp4" // 这个视频压缩为webm后还会变大
                        autoPlay
                        loop
                        muted
                        preload="metadata"
                        poster="https://websiteoss.ecoflow.com/upload/image/1754397510191/4-pc.jpg"
                        width="100%"
                        height="100%"
                        playsInline
                        aria-label={t('D_title')}
                    />
                )}
            </div>
            <div className="info">
                <p className="title">{t('D_title')}</p>
                <p className="desc">{t('D_desc')}</p>
            </div>
        </section>
    );
};

export default D;
